//
//
//
//
//
//
//
//
//
//
//
//
//
//
var isUploadComplete = function isUploadComplete(status) {
  return status === 'upload failed' || status === 'upload successful' || status === 'canceled';
};

export default {
  props: {
    id: {
      type: Number
    },
    hideBeforeStart: {
      type: Boolean,
      "default": true
    },
    hideOnComplete: {
      type: Boolean,
      "default": true
    },
    uploader: {
      type: Object,
      rquired: true
    }
  },
  data: function data() {
    return {
      state: {
        bytesUploaded: null,
        hidden: this.hideBeforeStart,
        totalSize: null
      },
      _unmounted: false
    };
  },
  created: function created() {
    this._createEventHandlers();
  },
  mounted: function mounted() {
    if (this._isTotalProgress) {
      this.uploader.on('totalProgress', this._trackProgressEventHandler);
    } else {
      this.uploader.on('progress', this._trackProgressEventHandler);
    }

    this.uploader.on('statusChange', this._trackStatusEventHandler);
  },
  beforeDestroy: function beforeDestroy() {
    this._unmounted = true;

    this._unregisterEventHandlers();
  },
  methods: {
    _createEventHandlers: function _createEventHandlers() {
      var _this = this;

      if (this._isTotalProgress) {
        this._trackProgressEventHandler = function (bytesUploaded, totalSize) {
          _this.$set(_this.state, 'bytesUploaded', bytesUploaded);

          _this.$set(_this.state, 'totalSize', totalSize);
        };
      } else {
        this._trackProgressEventHandler = function (id, name, bytesUploaded, totalSize) {
          if (id === _this.id) {
            _this.$set(_this.state, 'bytesUploaded', bytesUploaded);

            _this.$set(_this.state, 'totalSize', totalSize);
          }
        };
      }

      this._trackStatusEventHandler = function (id, oldStatus, newStatus) {
        if (!_this._unmounted) {
          if (_this._isTotalProgress) {
            if (!_this.state.hidden && _this.hideOnComplete && isUploadComplete(newStatus) && !_this.uploader.methods.getInProgress()) {
              _this.$set(_this.state, 'hidden', true);
            } else if (_this.state.hidden && _this.uploader.methods.getInProgress()) {
              _this.$set(_this.state, 'hidden', false);
            }
          } else if (id === _this.id) {
            if (_this.state.hidden && newStatus === 'uploading') {
              _this.$set(_this.state, 'hidden', false);
            } else if (!_this.state.hidden && _this.hideOnComplete && isUploadComplete(newStatus)) {
              _this.$set(_this.state, 'hidden', true);
            }
          }
        }
      };
    },
    _unregisterEventHandlers: function _unregisterEventHandlers() {
      if (this._isTotalProgress) {
        this.uploader.off('totalProgress', this._trackProgressEventHandler);
      } else {
        this.uploader.off('progress', this._trackProgressEventHandler);
      }

      this.uploader.off('statusChange', this._trackStatusEventHandler);
    }
  },
  computed: {
    _isTotalProgress: function _isTotalProgress() {
      return typeof this.id !== 'number';
    },
    className: function className() {
      return this._isTotalProgress ? 'vue-fine-uploader-total-progress-bar' : 'vue-fine-uploader-file-progress-bar';
    },
    containerClassName: function containerClassName() {
      return "".concat(this.className, "-container");
    },
    percentWidth: function percentWidth() {
      return this.state.bytesUploaded / this.state.totalSize * 100 || 0;
    }
  }
};